
export const DeliveryStepHeading = ( { children } ) => {
	return (
		<div className="wc-block-components-checkout-step__heading">
			<h2 className="wc-block-components-title wc-block-components-checkout-step__title" aria-hidden={ true }>
				{ children }
			</h2>
		</div>
	);
};
